import ExcelJS from "exceljs";
import { calculatesAverageValue, filteredAnswers } from "./utils";
import { getProductionDepartments } from "./data-table";
import { GroupRequirement, RequirementColumn, Department } from "../types/data";

export const exportToExcel = async (data, departments) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  console.log('departmentsArr', departments)

  worksheet.getRow(1).font = {
    bold: true,
  };

  const departmentTitles = new Set();

  data.forEach(item => {
      item.columnRequirements.forEach(req => {
          req.groupRequirements.forEach(group => {
              group.requirements.forEach(requirement => {
                  requirement.answers.forEach(answer => {
                      departmentTitles.add(answer.departmentTitle);
                  });
              });
          });
      });
  });

  const departmentColumns = Array.from(departmentTitles);

  worksheet.columns = [
    { header: 'Год', key: 'Год', width: 10 },
    { header: 'Месяц', key: 'Месяц', width: 15 },
    { header: 'Завод', key: 'Завод', width: 20 },
    { header: 'Группа', key: 'Группа', width: 10 },
    { header: 'Колонна', key: 'Колонна', width: 15 },
    { header: 'Блок', key: 'Блок', width: 30 },
    { header: 'Процесс', key: 'Процесс', width: 25 },
    { header: 'Уровень зрелости', key: 'Уровень зрелости', width: 15 },
    { header: 'Требование', key: 'Требование', width: 35 },
    { header: 'Показатель процесса', key: 'Показатель процесса', width: 35 },
    ...departmentColumns.map(dept => ({ header: dept, key: dept, width: 10 })),
    { header: 'Среднее по производствам', key: 'Среднее по производствам', width: 25 },
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 20 },
    { header: 'Кто завершил оценку', key: 'Кто завершил оценку', width: 20 },
    { header: 'Дата завершения', key: 'Дата завершения', width: 15 }
  ];

  // Заполняем строки
  data.forEach(item => {
    worksheet.addRow([
      item.year,
      item.month,
      item.factory,
      item.group,
      item.name,
      'Общая оценка',
      '',
      '',
      '',
      '',
      ...departmentColumns.map((el) =>
        calculatesAverageValue(item.columnRequirements, el) !== 'N/A'
          ? calculatesAverageValue(item.columnRequirements, el) + '%'
          : '',
      ),
      calculatesAverageValue(
        filteredAnswers(
          item.columnRequirements,
          departments.filter((el) => el.isProduction),
        ),
        undefined,
        true,
      ) !== 'N/A'
        ? calculatesAverageValue(
            filteredAnswers(
              item.columnRequirements,
              departments.filter((el) => el.isProduction),
            ),
            undefined,
            true,
          ) + '%'
        : '',
      calculatesAverageValue(item.columnRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(item.columnRequirements, undefined, true) + '%'
        : '',
      item.completedAssessment,
      item.completionDate,
    ]);

    item.columnRequirements.forEach(req => {
      worksheet.addRow([
        item.year,
        item.month,
        item.factory,
        item.group,
        item.name,
        req.name,
        'Оценка по блоку',
        '',
        '',
        '',
        ...departmentColumns.map((el) =>
          calculatesAverageValue(req.groupRequirements, el) !== 'N/A'
            ? calculatesAverageValue(req.groupRequirements, el) + '%'
            : '',
        ),
        calculatesAverageValue(
          filteredAnswers(req.groupRequirements, departments.filter((el) => el.isProduction)),
          undefined,
          true,
        ) !== 'N/A'
          ? calculatesAverageValue(
            filteredAnswers(req.groupRequirements, departments.filter((el) => el.isProduction)),
            undefined,
            true,
          ) + '%'
          : '',
        calculatesAverageValue(req.groupRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(req.groupRequirements, undefined, true) + '%'
        : '',
        item.completedAssessment,
        item.completionDate,
      ]);

      req.groupRequirements.forEach(group => {
        group.requirements.forEach(requirement => {
          const row = {
              'Год': item.year,
              'Месяц': item.month,
              'Завод': item.factory,
              'Группа': item.group,
              'Колонна': item.name,
              'Блок': req.name,
              'Процесс': group.name,
              'Уровень зрелости': MaturityLevel[requirement.type as MaturityLevelType],
              'Требование': requirement.name,
              'Показатель процесса': requirement.indicator
          };

          requirement.answers.forEach(answer => {
              row[answer.departmentTitle] = answer.disabled ? '-' : answer.answer.notСounted ? '' : answer.answer.title;
          });

          row['Среднее по производствам'] = calculatesAverageValue(requirement.answers) !== 'N/A' ? calculatesAverageValue(requirement.answers) + '%' : '';

          row['Среднее по заводу'] = calculatesAverageValue(requirement.answers) !== 'N/A' ? calculatesAverageValue(requirement.answers) + '%' : '';

          row['Кто завершил оценку'] = item.completedAssessment;

          row['Дата завершения'] = item.completionDate;

          worksheet.addRow(row);
      });
    });
  });
  });

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "data.xlsx";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const exportExcelMain = async (
  data: GroupRequirement[],
  departments: Department[],
  params: { column: { [key: string]: string | number }}
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`${params.column.title}`);

  worksheet.getRow(1).font = {
    bold: true,
  };

  worksheet.columns = [
    { header: 'Блок', key: 'Блок', width: 20 },
    { header: 'Процесс', key: 'Процесс', width: 20 },
    { header: 'Уровень зрелости', key: 'Уровень зрелости', width: 20 },
    { header: 'Требование', key: 'Требование', width: 40 },
    { header: 'Показатель процесса', key: 'Показатель процесса', width: 10 },
    { header: 'Как провести коучинг', key: 'Как провести коучинг', width: 50 },
    { header: 'Связь с другими колоннами', key: 'Связь с другими колоннами', width: 50 },
    { header: 'Дополнительная информация по внедрению требования', key: 'Дополнительная информация по внедрению требования', width: 50 },
    ...departments.map((department) => ({ header: department.title, key: department.title, width: 10 })),
    { header: 'Среднее по производствам', key: 'Среднее по производствам', width: 25 },
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 25 },
  ];

  worksheet.addRow([
    'Общая оценка',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    ...departments.map((el) => {
      const value = calculatesAverageValue(data, el.title)

      return value !== 'N/A' ? value + '%' : '';
    }),
    calculatesAverageValue(filteredAnswers(data, getProductionDepartments(departments)), undefined, true) !== 'N/A'
      ? calculatesAverageValue(filteredAnswers(data, getProductionDepartments(departments)), undefined, true) + '%'
      : '',
    calculatesAverageValue(data, undefined, true) !== 'N/A'
      ? calculatesAverageValue(data, undefined, true) + '%'
      : '',
  ])

  worksheet.getRow(2).font = { bold: true };

  data.forEach((item) => {
    worksheet.addRow([
      item.title,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      ...departments.map((el) => {
        const value = calculatesAverageValue(item.groupRequirements, el.title)

        return value !== 'N/A' ? value + '%' : '';
      }),
      calculatesAverageValue(
        filteredAnswers(item.groupRequirements, getProductionDepartments(departments)),
        undefined,
        true,
      ) !== 'N/A'
        ? calculatesAverageValue(
            filteredAnswers(item.groupRequirements, getProductionDepartments(departments)),
            undefined,
            true,
          ) + '%'
        : '',
      calculatesAverageValue(item.groupRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(item.groupRequirements, undefined, true) + '%'
        : '',
    ])

    item.groupRequirements.forEach((process) => {
      process.requirements.forEach((requirement) => {
        worksheet.addRow([
          item.title,
          process.title,
          requirement.maturityLevel === 'Все' || !requirement.maturityLevel ? 0 : requirement.maturityLevel,
          requirement.title,
          requirement.indicator,
          process.information?.text,
          requirement.connectionColumns?.text,
          requirement.information?.text,
          ...requirement.answers.map((el) => el.answer),
          calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) !== 'N/A'
            ? calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) + '%'
            : '',
          calculatesAverageValue(requirement.answers) !== 'N/A'
            ? calculatesAverageValue(requirement.answers) + '%'
            : '',
        ])
      })
    })
  })

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${params.column.title}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const exportExcelSummary = async (
  data: RequirementColumn[],
  departments: Department[],
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('vpo-summary');

  worksheet.getRow(1).font = {
    bold: true,
  };

  worksheet.columns = [
    { header: 'Колонна', key: 'Колонна', width: 20 },
    { header: 'Блок', key: 'Блок', width: 20 },
    { header: 'Процесс', key: 'Процесс', width: 20 },
    { header: 'Уровень зрелости', key: 'Уровень зрелости', width: 20 },
    { header: 'Требование', key: 'Требование', width: 40 },
    { header: 'Показатель процесса', key: 'Показатель процесса', width: 10 },
    ...departments.map((department) => ({ header: department.title, key: department.title, width: 10 })),
    { header: 'Среднее по производствам', key: 'Среднее по производствам', width: 25 },
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 25 },
  ];

  data.forEach((column) => {
    worksheet.addRow([
      column.title,
      '',
      '',
      '',
      '',
      '',
      ...departments.map((el) => {
        const value = calculatesAverageValue(column.columnRequirements, el.title)

        return value !== 'N/A' ? value + '%' : '';
      }),
      calculatesAverageValue(
        filteredAnswers(column.columnRequirements, getProductionDepartments(departments)),
        undefined,
        true,
      ) !== 'N/A'
        ? calculatesAverageValue(
            filteredAnswers(column.columnRequirements, getProductionDepartments(departments)),
            undefined,
            true,
          ) + '%'
        : calculatesAverageValue(
            filteredAnswers(column.columnRequirements, getProductionDepartments(departments)),
            undefined,
            true,
          ),
      calculatesAverageValue(column.columnRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(column.columnRequirements, undefined, true) + '%'
        : calculatesAverageValue(column.columnRequirements, undefined, true),
    ])

    column.columnRequirements.forEach((block) => {
      worksheet.addRow([
        column.title,
        block.title,
        '',
        '',
        '',
        '',
        ...departments.map((el) => {
          const value = calculatesAverageValue(block.groupRequirements, el.title)

          return value !== 'N/A' ? value + '%' : '';
        }),
        calculatesAverageValue(
          filteredAnswers(block.groupRequirements, getProductionDepartments(departments)),
          undefined,
          true,
        ) !== 'N/A'
          ? calculatesAverageValue(
              filteredAnswers(block.groupRequirements, getProductionDepartments(departments)),
              undefined,
              true,
            ) + '%'
          : calculatesAverageValue(
              filteredAnswers(block.groupRequirements, getProductionDepartments(departments)),
              undefined,
              true,
            ),
        calculatesAverageValue(block.groupRequirements, undefined, true) !== 'N/A'
          ? calculatesAverageValue(block.groupRequirements, undefined, true) + '%'
          : calculatesAverageValue(block.groupRequirements, undefined, true),
      ])

      block.groupRequirements.forEach((process) => {
        process.requirements.forEach((requirement) => {
          worksheet.addRow([
            column.title,
            block.title,
            process.title,
            requirement.maturityLevel === 'Все' || !requirement.maturityLevel ? 0 : requirement.maturityLevel,
            requirement.title,
            requirement.indicator,
            ...requirement.answers.map((el) => el.noRender ? '' : el.answer),
            calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) !== 'N/A'
              ? calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) + '%'
              : calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))),
            calculatesAverageValue(requirement.answers) !== 'N/A'
              ? calculatesAverageValue(requirement.answers) + '%'
              : calculatesAverageValue(requirement.answers),
          ])
        })
      })
    })
  })

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = 'vpo-summary.xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const exportExcelFactory = async (
  data: RequirementColumn[],
  departments: Department[],
  params: {
    group: string;
  }
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('data');

  worksheet.getRow(1).font = {
    bold: true,
  };

  worksheet.columns = [
    { header: 'Год', key: 'Год', width: 20 },
    { header: 'Месяц', key: 'Месяц', width: 20 },
    { header: 'Завод', key: 'Завод', width: 20 },
    { header: 'Группа', key: 'Группа', width: 20 },
    { header: 'Колонна', key: 'Колонна', width: 20 },
    { header: 'Блок', key: 'Блок', width: 20 },
    { header: 'Процесс', key: 'Процесс', width: 20 },
    { header: 'Уровень зрелости', key: 'Уровень зрелости', width: 20 },
    { header: 'Требование', key: 'Требование', width: 40 },
    { header: 'Показатель процесса', key: 'Показатель процесса', width: 10 },
    ...departments.map((department) => ({ header: department.title, key: department.title, width: 10 })),
    { header: 'Среднее по производствам', key: 'Среднее по производствам', width: 25 },
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 25 },
    { header: 'Кто завершил оценку', key: 'Кто завершил оценку', width: 25 },
    { header: 'Дата завершения', key: 'Дата завершения', width: 25 },
  ];

  data.forEach((column) => {
    worksheet.addRow([
      column.year,
      column.month,
      column.factory,
      params.group,
      column.title,
      'Общая оценка',
      '',
      '',
      '',
      '',
      ...departments.map((el) => {
        const value = calculatesAverageValue(column.columnRequirements, el.title)

        return value !== 'N/A' ? value + '%' : '';
      }),
      calculatesAverageValue(
        filteredAnswers(column.columnRequirements, getProductionDepartments(departments)),
        undefined,
        true,
      ) !== 'N/A'
        ? calculatesAverageValue(
            filteredAnswers(column.columnRequirements, getProductionDepartments(departments)),
            undefined,
            true,
          ) + '%'
        : '',
      calculatesAverageValue(column.columnRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(column.columnRequirements, undefined, true) + '%'
        : '',
      column.completedAssessment,
      column.completionDate
    ])

    column.columnRequirements.forEach((block) => {
      worksheet.addRow([
        column.year,
        column.month,
        column.factory,
        params.group,
        column.title,
        block.title,
        'Оценка по блоку',
        '',
        '',
        '',
        ...departments.map((el) => {
          const value = calculatesAverageValue(block.groupRequirements, el.title)

          return value !== 'N/A' ? value + '%' : '';
        }),
        calculatesAverageValue(
          filteredAnswers(block.groupRequirements, getProductionDepartments(departments)),
          undefined,
          true,
        ) !== 'N/A'
          ? calculatesAverageValue(
              filteredAnswers(block.groupRequirements, getProductionDepartments(departments)),
              undefined,
              true,
            ) + '%'
          : '',
        calculatesAverageValue(block.groupRequirements, undefined, true) !== 'N/A'
          ? calculatesAverageValue(block.groupRequirements, undefined, true) + '%'
          : '',
        column.completedAssessment,
        column.completionDate
      ])

      block.groupRequirements.forEach((process) => {
        process.requirements.forEach((requirement) => {
          worksheet.addRow([
            column.year,
            column.month,
            column.factory,
            params.group,
            column.title,
            block.title,
            process.title,
            requirement.maturityLevel === 'Все' || !requirement.maturityLevel ? 0 : requirement.maturityLevel,
            requirement.title,
            requirement.indicator,
            ...requirement.answers.map((el) => el.noRender ? '' : el.answer),
            calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) !== 'N/A'
              ? calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))) + '%'
              : calculatesAverageValue(filteredAnswers(requirement.answers, getProductionDepartments(departments))),
            calculatesAverageValue(requirement.answers) !== 'N/A'
              ? calculatesAverageValue(requirement.answers) + '%'
              : calculatesAverageValue(requirement.answers),
            column.completedAssessment,
            column.completionDate
          ])
        })
      })
    })
  })

  const maturityColIndex = worksheet.columns.findIndex((col) => col.key === 'Уровень зрелости') + 1;
  if (maturityColIndex > 0) {
    worksheet.getColumn(maturityColIndex).alignment = { horizontal: 'left' };
  }

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = 'data.xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
